const apiUrl = () => {
  switch (window.TAPPY_ENV) {
    case 'staging':
      return 'https://api-staging.np.dealshield.com/graphql';
    case 'qa':
      return 'https://api-qa.np.dealshield.com/graphql';
    case 'production':
      return 'https://api.dealshield.com/graphql';
    case 'development':
      return process.env.REACT_APP_API_URL;
    default:
      return process.env.REACT_APP_API_URL;
  }
};

const API_URL = apiUrl();

// With HashRouter the query string lives inside window.location.hash (e.g. #/path?FLAG=true),
// not in window.location.search, so we parse from the hash fragment.
const _hashQuery = window.location.hash.includes('?')
  ? window.location.hash.split('?')[1]
  : window.location.search.slice(1);

const getFeatureFlag = (paramName, envVar) => {
  const qp = new URLSearchParams(_hashQuery).get(paramName);
  return qp !== null ? qp === 'true' : process.env[envVar] === 'true';
};

export const GUARANTEES_V2_ENABLED = getFeatureFlag(
  'GUARANTEES',
  'REACT_APP_GUARANTEES_V2_ENABLED'
);
export const ELIGIBILITY_ENGINE_ENABLED = getFeatureFlag(
  'ElEng',
  'REACT_APP_ELIGIBILITY_ENGINE_ENABLED'
);
export const MULTI_SUBSCRIPTION_ENABLED = getFeatureFlag(
  'MULTI_SUBSCRIPTION',
  'REACT_APP_MULTI_SUBSCRIPTION_ENABLED'
);
export default API_URL;
